import { render, staticRenderFns } from "./technologyList.vue?vue&type=template&id=24f6c68c&scoped=true"
import script from "./technologyList.vue?vue&type=script&lang=js"
export * from "./technologyList.vue?vue&type=script&lang=js"
import style0 from "./technologyList.vue?vue&type=style&index=0&id=24f6c68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6c68c",
  null
  
)

export default component.exports